
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/terms-conditions-hub",
      function () {
        return require("private-next-pages/[lang]/terms-conditions-hub.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/terms-conditions-hub"])
      });
    }
  